import { Stack, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from 'redux/Hook'
import { useToolBuilder } from 'containers/ToolBuilder/Hook'

function ToolHeader() {
  const { t } = useTranslation()
  const { projectId } = useToolBuilder()
  const { toolBuilder } = useAppSelector((state) => state.toolBuilder)

  return (
    <Stack spacing={{ md: 2 }} direction="row" alignItems="center">
      <IconButton
        aria-label={t('common.close')}
        onClick={() => (window.location.href = `/admin/projects/${projectId}`)}
      >
        <CloseIcon sx={{ color: 'white' }} />
      </IconButton>
      {toolBuilder['title'] && (
        <Typography
          noWrap
          variant="h2"
          color="white"
          fontSize={24}
          fontWeight={400}
        >
          {toolBuilder['title']}
        </Typography>
      )}
    </Stack>
  )
}

export default ToolHeader
